import { useEffect } from "react";
import { PRIMARY_LOGO_URL } from "@/lib/api";

const SITE = "The Canary Report";
const DEFAULT_DESC =
  "Advocacy journalism rooted in community — documenting how economic systems impact Black women, using their experiences as the earliest indicator of shifts that reach us all.";
const DEFAULT_IMAGE = PRIMARY_LOGO_URL;

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Lightweight, dependency-free SEO / social-share tag manager.
export default function Seo({ title, description = DEFAULT_DESC, image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const full = title ? `${title} · ${SITE}` : `${SITE} — Advocacy Journalism`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
  }, [title, description, image]);

  return null;
}
